export const InvoiceSummarySeparator = () => {

  return (
    <div className={ 'col-span-full h-[1px] bg-[#ABB0C7]/30' } />
  )
}
InvoiceSummarySeparator.displayName = 'InvoiceSummarySeparator';
